﻿import { ValidationSummary } from 'shared/data/validation';

export class ValidationSummaryRequested {
    validationSummary: ValidationSummary;

    static eventName() { return 'ValidationSummaryRequested'; }

    eventName = ValidationSummaryRequested.eventName;
}